<div class="diagram">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -4 520 590">
    <g id="Sedan" transform="translate(-465 -106)">
      <g id="Group_1212" data-name="Group 1212" transform="translate(28 5)">
        <g id="Group_904" data-name="Group 904">
          <circle
            id="Ellipse_67"
            data-name="Ellipse 67"
            cx="3"
            cy="3"
            r="3"
            transform="translate(637 421)"
            class="arrowDot"
            fill="#696969"
          />
        </g>
        <g id="Group_855" data-name="Group 855" transform="translate(404.547 80.574)">
          <path
            id="Path_561"
            data-name="Path 561"
            d="M572.777,418.513l.361,14.109-4.273,3.708Z"
            transform="translate(-208.925 -183.312)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_566"
            data-name="Path 566"
            d="M550.571,764.108l7.556-2.449s-1,14.9-2.022,16.088l-4.6,1.426Z"
            transform="translate(-198.098 -386.388)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_569"
            data-name="Path 569"
            d="M557.64,579.689s8.221,1.742,10.042-82.015-.459-88.094-.459-88.094"
            transform="translate(-202.282 -178.025)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_570"
            data-name="Path 570"
            d="M560.028,401.828s-.57-41.591,0-45.615-1.682-90.023-1.682-90.023c-1.334-62.018-20.685-93.134-20.685-93.134"
            transform="translate(-190.458 -38.049)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_577"
            data-name="Path 577"
            d="M302.226,161.531"
            transform="translate(-51.126 -31.228)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <g
            id="Path_578"
            data-name="Path 578"
            transform="translate(-27.146 -31.228)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M261.707,190.225s10.026-20.273,16.54-28.694a17.452,17.452,0,0,0-6.044,4.552C268.52,170.051,263.9,177.651,261.707,190.225Z"
              stroke="none"
            />
            <path
              d="M 262.919921875 186.7219085693359 C 265.7810974121094 181.1454162597656 271.7867431640625 169.7722625732422 276.5277099609375 163.0265808105469 C 275.4808044433594 163.7095489501953 274.0858154296875 164.7889099121094 272.5689392089844 166.4232635498047 C 271.0985717773438 168.0077209472656 268.9125366210938 170.8065032958984 266.8482055664062 175.1419067382812 C 265.20458984375 178.5937347412109 263.88818359375 182.4764862060547 262.919921875 186.7219085693359 M 261.7070007324219 190.2248687744141 C 263.9014282226562 177.6513366699219 268.5201416015625 170.0512084960938 272.2024230957031 166.0831604003906 C 275.5177612304688 162.5110778808594 278.2465209960938 161.531005859375 278.2465209960938 161.531005859375 C 271.7330017089844 169.9520263671875 261.7070007324219 190.2248687744141 261.7070007324219 190.2248687744141 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_579"
            data-name="Path 579"
            transform="translate(-27.146 -45.501)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M261.707,204.5s.964-14.54,4.3-18.766l2.274-.083S262.273,197.59,261.707,204.5Z"
              stroke="none"
            />
            <path
              d="M 263.1460266113281 196.4995269775391 C 263.6012268066406 195.1885375976562 264.134033203125 193.7856903076172 264.74365234375 192.2939605712891 C 265.8435363769531 189.6024169921875 266.9194641113281 187.3103637695312 267.4651489257812 186.1790771484375 L 266.2630004882812 186.2228698730469 C 264.7712707519531 188.2883148193359 263.7767333984375 192.5867614746094 263.1460266113281 196.4995269775391 M 261.7070007324219 204.4980773925781 C 261.7070007324219 204.4980773925781 262.6707458496094 189.9578704833984 266.0072937011719 185.7318572998047 L 268.2813415527344 185.6490020751953 C 268.2813415527344 185.6490020751953 262.2731628417969 197.5902557373047 261.7070007324219 204.4980773925781 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_580"
            data-name="Path 580"
            transform="translate(-31.216 -37.828)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M276.272,172.683s-7.058,1.273-7.689,5.43l3.768-.137A24.092,24.092,0,0,1,276.272,172.683Z"
              stroke="none"
            />
            <path
              d="M 274.7345886230469 173.5937194824219 C 272.8724975585938 174.1707611083984 269.9815979003906 175.3965759277344 269.2249450683594 177.5890808105469 L 272.04931640625 177.4862518310547 C 272.4043579101562 176.8552856445312 273.3970031738281 175.1740264892578 274.7345886230469 173.5937194824219 M 276.271728515625 172.6829833984375 C 274.0307312011719 174.8162231445312 272.3506164550781 177.9756164550781 272.3506164550781 177.9756164550781 L 268.5830078125 178.11279296875 C 269.2132568359375 173.9557189941406 276.271728515625 172.6829833984375 276.271728515625 172.6829833984375 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_581"
            data-name="Path 581"
            transform="translate(-191.869 -31.227)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M540.046,161.529s12.816,2.889,15.708,26.966C555.754,188.495,541.52,162.2,540.046,161.529Z"
              stroke="none"
            />
            <path
              d="M 541.6060791015625 162.6703948974609 C 542.7206420898438 164.3246154785156 544.8104248046875 167.7639465332031 548.8882446289062 175.017822265625 C 551.2197875976562 179.1652069091797 553.4981689453125 183.3139495849609 554.874267578125 185.8334655761719 C 554.1761474609375 181.5313568115234 553.0944213867188 177.6902618408203 551.6484375 174.3857421875 C 550.2581176757812 171.2086029052734 548.5301513671875 168.5184173583984 546.512451171875 166.389892578125 C 544.721923828125 164.5009918212891 543.029052734375 163.41259765625 541.9241943359375 162.8321533203125 C 541.8145751953125 162.7745666503906 541.70849609375 162.7207336425781 541.6060791015625 162.6703948974609 M 540.0460205078125 161.5290069580078 C 540.0460205078125 161.5290069580078 552.8623657226562 164.4181823730469 555.753662109375 188.4945831298828 C 555.753662109375 188.4945831298828 541.51953125 162.1984558105469 540.0460205078125 161.5290069580078 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <path
            id="Path_582"
            data-name="Path 582"
            d="M556.414,173.057s6.561,1.279,7.08,5.171l-3.54-.232S559.862,177.116,556.414,173.057Z"
            transform="translate(-201.556 -38.049)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_583"
            data-name="Path 583"
            d="M571.871,204.776s-.252-15.871-4.606-19.387l-2.178-.232a39.331,39.331,0,0,1,4.967,15.82"
            transform="translate(-206.689 -45.21)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_587"
            data-name="Path 587"
            d="M273.938,364.918s1.489-.491,2.2-7.674c0,0,6.7-13.641,52.031-13.641s60,10.658,60,10.658a10.614,10.614,0,0,1,2.3,5.208,15.4,15.4,0,0,0,1.5,5.143s.538.547.927-.324,1.487-9.339-.985-12.041-8.406-14.011-64.178-15.126C271.156,337.6,268.786,359.988,273.938,364.918Z"
            transform="translate(-33.308 -135.143)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_590"
            data-name="Path 590"
            d="M548.765,657.225"
            transform="translate(-197.029 -324.583)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_591"
            data-name="Path 591"
            d="M304.454,532.448s7.526,63.373,4.208,108.048"
            transform="translate(-52.444 -250.74)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_592"
            data-name="Path 592"
            d="M531.663,532.625s-6.235,29.953-5.15,108.062"
            transform="translate(-183.786 -250.844)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_595"
            data-name="Path 595"
            d="M262.917,418.475l-.361,14.109,4.273,3.708Z"
            transform="translate(-27.648 -183.289)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_600"
            data-name="Path 600"
            d="M280.363,764.07l-7.556-2.449s1,14.9,2.022,16.088l4.6,1.426Z"
            transform="translate(-33.715 -386.366)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_603"
            data-name="Path 603"
            d="M268.669,579.65s-8.221,1.743-10.042-82.015.46-88.094.46-88.094"
            transform="translate(-24.906 -178.002)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_604"
            data-name="Path 604"
            d="M249.3,401.79s.57-41.591,0-45.615,1.682-90.023,1.682-90.023c1.334-62.019,20.684-93.134,20.684-93.134"
            transform="translate(-19.749 -38.026)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_610"
            data-name="Path 610"
            d="M493.488,775.465l-.329,50.265s-3.193,28.469-15.97,39.145-34.2,12.752-58.038,12.752"
            transform="translate(-120.323 -394.559)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_611"
            data-name="Path 611"
            d="M240.337,775.465l.329,50.265s3.193,28.469,15.97,39.145,34.2,12.752,58.038,12.752"
            transform="translate(-14.499 -394.559)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_614"
            data-name="Path 614"
            d="M284.25,954.182s9.656,18.683,55.066,18.831c0,0,40.905,2.32,57.355-18.831"
            transform="translate(-40.487 -500.325)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <ellipse
            id="Ellipse_230"
            data-name="Ellipse 230"
            cx="4.482"
            cy="1.636"
            rx="4.482"
            ry="1.636"
            transform="translate(293.533 473.708)"
            fill="#030504"
          />
          <path
            id="Path_617"
            data-name="Path 617"
            d="M328.6,1002.271s-9.5-1.442-12.907-8.172"
            transform="translate(-59.098 -523.948)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_618"
            data-name="Path 618"
            d="M495.888,1001.948s10.027-1.552,12.575-7.893"
            transform="translate(-165.736 -523.922)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_619"
            data-name="Path 619"
            d="M243.156,161.321s-.5-40.413,44.008-47.869"
            transform="translate(-16.167 -2.774)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_620"
            data-name="Path 620"
            d="M490.926,113.452c44.513,7.456,44.008,47.869,44.008,47.869"
            transform="translate(-162.8 -2.774)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
      </g>
      <text
        id="Sedan-2"
        data-name="Sedan"
        transform="translate(706 127)"
        font-size="14"
        font-weight="700"
      >
        <tspan x="0" y="0">Sedan</tspan>
      </text>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['hood'] || ''"
        [attr.data-name]="'exterior.sedan.hood' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_22"
          data-name="Path 22"
          d="M6170.672,1108.138l85-83.25h24.994"
          transform="translate(-5461.672 -888.598)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="94"
          height="18"
          rx="9"
          transform="translate(817 127)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 127)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="3"
          cy="3"
          r="3"
          transform="translate(707 216)"
          class="arrowDot"
          fill="#696969"
        />
        <g
          id="Path_576"
          data-name="Path 576"
          transform="translate(374.514 78.015)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M266.586,232.917s5.382-86.4,32.587-117.463c0,0,6-2,27.949-2.241,13.176-.167,27.281-.631,34.357,2.5,6.768,4.668,24.9,45.122,29.744,98.537l2.177,18.273s-2.3-1.26-3.781-.816c0,0,1.843-8.6-1.265-12.012-.662-.725-1.252-1.512-1.93-2.223a19.294,19.294,0,0,0-3.59-2.923,34.167,34.167,0,0,0-6.693-3.195,77.311,77.311,0,0,0-11.247-3.045,172.875,172.875,0,0,0-17.253-2.476,198.927,198.927,0,0,0-26.947-1.187,152.906,152.906,0,0,0-21.442,2.146,76.207,76.207,0,0,0-14.486,3.937,37.814,37.814,0,0,0-8.893,4.8,20.454,20.454,0,0,0-4.663,4.735,12.706,12.706,0,0,0-1.8,3.742,8.128,8.128,0,0,0-.269,1.4,18.464,18.464,0,0,0,.741,6.376Z"
            stroke="none"
          />
          <path
            d="M 267.1364440917969 232.1978912353516 L 269.2731018066406 231.4594879150391 C 268.9943542480469 230.4273834228516 268.4066162109375 227.8659210205078 268.6459350585938 225.3542785644531 C 268.6902465820312 224.8871002197266 268.7835998535156 224.4010162353516 268.9312133789062 223.8684844970703 C 269.2895812988281 222.5731811523438 269.9168090820312 221.2640686035156 270.7954406738281 219.9776000976562 C 271.9710998535156 218.25537109375 273.5777282714844 216.6226348876953 275.5707397460938 215.124755859375 C 278.0393371582031 213.2694091796875 280.9864501953125 211.6782073974609 284.5804443359375 210.2602691650391 C 288.77294921875 208.6056518554688 293.5423889160156 207.3091583251953 299.1612548828125 206.2966918945312 C 305.5331115722656 205.1485443115234 312.5696411132812 204.4441375732422 320.6729431152344 204.1432342529297 C 322.2947998046875 204.0830535888672 323.9803466796875 204.0525512695312 325.6828002929688 204.0525512695312 C 333.7174377441406 204.0525512695312 341.6632080078125 204.7367095947266 347.6878662109375 205.3327331542969 C 354.3882141113281 205.9950714111328 359.8863525390625 206.7841186523438 364.9907531738281 207.8159027099609 C 369.4666137695312 208.7203063964844 373.0635986328125 209.6942901611328 376.3107604980469 210.8811187744141 C 379.0466003417969 211.8815765380859 381.204345703125 212.9119720458984 383.1013793945312 214.1239013671875 C 384.4981079101562 215.0164184570312 385.7371215820312 216.0255279541016 386.7840881347656 217.1232147216797 C 387.1697387695312 217.5276641845703 387.5283813476562 217.9563751220703 387.875244140625 218.3709716796875 C 388.1492919921875 218.6985168457031 388.4326782226562 219.0372314453125 388.7220153808594 219.3544158935547 C 391.4676208496094 222.3657073974609 390.6135559082031 228.9397125244141 390.2390441894531 231.1091766357422 C 390.26904296875 231.1084289550781 390.2992858886719 231.1080474853516 390.3297119140625 231.1080474853516 C 391.2029724121094 231.1080474853516 392.1419067382812 231.4161529541016 392.7962341308594 231.6857147216797 L 390.7252807617188 214.3047485351562 C 390.7247314453125 214.3001098632812 390.7242431640625 214.2954559326172 390.7238159179688 214.2907867431641 C 389.5921325683594 201.8170013427734 387.6640625 189.2968597412109 384.9931640625 177.0780944824219 C 382.6731872558594 166.4645385742188 379.8486022949219 156.2976989746094 376.5979309082031 146.8599700927734 C 370.3803405761719 128.808349609375 364.2869567871094 118.3057174682617 361.2319030761719 116.1464004516602 C 356.0821838378906 113.8917846679688 347.0611877441406 113.5870208740234 338.9109497070312 113.5870208740234 C 336.0188598632812 113.5870208740234 333.012451171875 113.6300582885742 330.1050415039062 113.6716690063477 C 329.1095886230469 113.685920715332 328.1159973144531 113.7001419067383 327.1267700195312 113.7127075195312 C 315.8758239746094 113.8357543945312 308.9204406738281 114.4308853149414 305.0667724609375 114.9084701538086 C 301.5389709472656 115.3456649780273 299.8927001953125 115.7670669555664 299.4544067382812 115.891357421875 C 293.3303527832031 122.9267883300781 287.8208618164062 133.4161682128906 283.0780334472656 147.0710754394531 C 279.2552795410156 158.0770416259766 275.9220581054688 171.1460418701172 273.1709899902344 185.9150543212891 C 268.9738464355469 208.4471282958984 267.4242553710938 228.1659240722656 267.1364440917969 232.1978912353516 M 266.5859985351562 232.9171447753906 C 266.5859985351562 232.9171447753906 271.9675903320312 146.5171508789062 299.1727600097656 115.4537200927734 C 299.1727600097656 115.4537200927734 305.1748657226562 113.452751159668 327.1213073730469 113.2127380371094 C 331.0386962890625 113.1629791259766 335.03857421875 113.0870208740234 338.9109497070312 113.0870208740234 C 348.0635986328125 113.0870208740234 356.5059814453125 113.5112609863281 361.4779968261719 115.7084197998047 C 368.2462158203125 120.3769226074219 386.3756713867188 160.830810546875 391.2217712402344 214.24560546875 L 393.3990173339844 232.5187377929688 C 393.3990173339844 232.5187377929688 391.7383728027344 231.6080474853516 390.3297424316406 231.6080474853516 C 390.0810852050781 231.6080474853516 389.8403930664062 231.6364135742188 389.6179504394531 231.7031555175781 C 389.6179504394531 231.7031555175781 391.4609680175781 223.1005096435547 388.3525390625 219.6912994384766 C 387.6908569335938 218.9659423828125 387.1006469726562 218.1797790527344 386.4222106933594 217.4682769775391 C 385.3523559570312 216.3465728759766 384.1371765136719 215.379150390625 382.8321533203125 214.5452270507812 C 380.7446899414062 213.2116546630859 378.4608459472656 212.1997528076172 376.1390380859375 211.3507080078125 C 372.4881896972656 210.0163269042969 368.6976928710938 209.0750427246094 364.8917236328125 208.3059997558594 C 359.1949768066406 207.1544952392578 353.4198608398438 206.4017944335938 347.638671875 205.8303070068359 C 340.3411865234375 205.1083679199219 333.0156555175781 204.5525512695312 325.6828308105469 204.5525512695312 C 324.0190124511719 204.5525512695312 322.3559265136719 204.5811309814453 320.6914672851562 204.6428833007812 C 313.5133666992188 204.9094390869141 306.32470703125 205.5139617919922 299.2499084472656 206.7887725830078 C 294.3251037597656 207.6761779785156 289.425537109375 208.8856353759766 284.7640075683594 210.7253570556641 C 281.6290893554688 211.9621734619141 278.5725402832031 213.4941253662109 275.8711242675781 215.5244598388672 C 274.0967407226562 216.8580322265625 272.4639587402344 218.4202117919922 271.2083740234375 220.2595062255859 C 270.4266662597656 221.4040679931641 269.7837524414062 222.6621246337891 269.4131164550781 224.0018005371094 C 269.2861633300781 224.4598083496094 269.1886291503906 224.9279937744141 269.1437072753906 225.4014892578125 C 268.8469848632812 228.5151977539062 269.8849792480469 231.7770538330078 269.8849792480469 231.7770538330078 L 266.5859985351562 232.9171447753906 Z"
            stroke="none"
            fill="#030504"
          />
        </g>
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(819 140)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Hood-2"
          data-name="Hood"
          transform="translate(840 139)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.hood' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_mud_guard'] || ''"
        [attr.data-name]="'exterior.sedan.rht_mud_guard' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_621"
          data-name="Path 621"
          d="M598.43,230.723l1.737,2.6,1.571,51.265-3.521,3.477Z"
          transform="translate(178.252 8.397)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_86"
          data-name="Path 86"
          d="M6227.364,1133.978l24.25-35.513H6267.1"
          transform="translate(-5447.417 -878.925)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(817 209)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 209)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_46"
          data-name="Ellipse 46"
          cx="3"
          cy="3"
          r="3"
          transform="translate(777 252)"
          class="arrowDot"
          fill="#696969"
        />
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(819 222)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Mud_Guard-2"
          data-name="RHT Mud Guard"
          transform="translate(840 221)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_mud_guard' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_window'] || ''"
        [attr.data-name]="'exterior.sedan.rht_frt_window' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_323"
          data-name="Path 323"
          d="M6224,1200.139l37.092-31.892h24.288"
          transform="translate(-5461.833 -831.113)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="128"
          height="18"
          rx="9"
          transform="translate(817 328)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 328)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_49"
          data-name="Ellipse 49"
          cx="3"
          cy="3"
          r="3"
          transform="translate(759 366)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_560"
          data-name="Path 560"
          d="M550.251,522.694s9.268-5.264,10.231-7.562.848-62.053.848-62.053l-4.273,3.708s-7.407,35.363-8.144,65.908v.723Z"
          transform="translate(207.431 -123.194)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(819 340)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_FRT_Window-2"
          data-name="RHT FRT Window"
          transform="translate(840 340)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_frt_window' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_door_lock'] || ''"
        [attr.data-name]="'exterior.sedan.rht_frt_door_lock' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_562"
          data-name="Path 562"
          d="M597.562,580.764s-1.687,1.446-1.835.964c-.057-.186-.125-2.867-.152-6.19-.042-5.288.024-12.2.411-13.271,1-1.334,1.345.963,1.345.963Z"
          transform="translate(179.821 -187.566)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_563"
          data-name="Path 563"
          d="M595.592,581.411l1.906-.871-.1-7.581-1.72-1.185Z"
          transform="translate(179.805 -193.439)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="140"
          height="18"
          rx="9"
          transform="translate(817 358)"
          fill="#242e3a"
          opacity="0.066"
        />
        <path
          id="Path_32"
          data-name="Path 32"
          d="M6221.276,1322.345,6245.884,1311h13.373"
          transform="translate(-5442.804 -943.672)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 358)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_50"
          data-name="Ellipse 50"
          cx="3"
          cy="3"
          r="3"
          transform="translate(775 376)"
          class="arrowDot"
          fill="#8d8989"
        />
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(819 370)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_FRT_Door_Lock-2"
          data-name="RHT FRT Door Lock"
          transform="translate(840 370)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_frt_door_lock' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rocker_panel'] || ''"
        [attr.data-name]="'exterior.sedan.rht_rocker_panel' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_33"
          data-name="Path 33"
          d="M6207,1322.24l4.36-.288,4.57-.3,4.352-.287,18.143-1.2h11.165"
          transform="translate(-5431 -921.709)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="119"
          height="18"
          rx="9"
          transform="translate(817 389)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 389)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_51"
          data-name="Ellipse 51"
          cx="3"
          cy="3"
          r="3"
          transform="translate(773 398)"
          class="arrowDot"
          fill="#696969"
        />
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(819 401)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Rocker_Panel-2"
          data-name="RHT Rocker Panel"
          transform="translate(840 401)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_rocker_panel' | translate }}</tspan>
        </text>
        <path
          id="Path_571"
          data-name="Path 571"
          d="M592.339,401.339s-2.562-.54-3.976.3l1.463,63.123.3,14.962-.011,9.388-.082,2.1s-.287,9.278-.248,17.2.248,29.192.248,29.192l3.714-.278Z"
          transform="translate(184.083 -92.473)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_door'] || ''"
        [attr.data-name]="'exterior.sedan.rht_rr_door' | translate"
        transform="translate(28 5)"
      >
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="116"
          height="18"
          rx="9"
          transform="translate(817 422)"
          fill="#242e3a"
          opacity="0.066"
        />
        <path
          id="Path_324"
          data-name="Path 324"
          d="M6207,1320.168l4.975,1.729,5.213,1.812,4.965,1.725,20.7,7.193h12.737"
          transform="translate(-5437 -902.168)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 422)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_52"
          data-name="Ellipse 52"
          cx="3"
          cy="3"
          r="3"
          transform="translate(768 415)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_564"
          data-name="Path 564"
          d="M548.831,627.277c.338.007-.714,71.031,3.6,75.028h10.305s5.956-5.968,7.093-12.641.08-72.9.08-72.9-2.28,2.391-9.119,3.892Z"
          transform="translate(207.479 -220.067)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(819 434)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_RR_Door-2"
          data-name="RHT RR Door"
          transform="translate(840 434)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_rr_door' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_window'] || ''"
        [attr.data-name]="'exterior.sedan.rht_rr_window' | translate"
        transform="translate(28 5)"
      >
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="118"
          height="18"
          rx="9"
          transform="translate(817 450)"
          fill="#242e3a"
          opacity="0.066"
        />
        <path
          id="Path_34"
          data-name="Path 34"
          d="M6217,1348l38.92,34.748h18.158"
          transform="translate(-5456.414 -924)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 450)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_53"
          data-name="Ellipse 53"
          cx="3"
          cy="3"
          r="3"
          transform="translate(758 421)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_565"
          data-name="Path 565"
          d="M549.043,651.7l10.628-3.741-2.536,44.779L549.6,694.8Z"
          transform="translate(207.354 -238.528)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(819 462)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_RR_Window-2"
          data-name="RHT RR Window"
          transform="translate(840 462)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_rr_window' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_door_lock'] || ''"
        [attr.data-name]="'exterior.sedan.rht_rr_door_lock' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_325"
          data-name="Path 325"
          d="M6217,1348l31.137,23.748h14.526"
          transform="translate(-5445 -883)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="132"
          height="18"
          rx="9"
          transform="translate(817 481)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 481)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_56"
          data-name="Ellipse 56"
          cx="3"
          cy="3"
          r="3"
          transform="translate(769 462)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_567"
          data-name="Path 567"
          d="M591.454,764.513s1.335.815,1.557-4.559,0-10.787,0-10.787-.149-3.522-.964-3.818-1.26,1.223-1.26,1.223V763.7S590.843,764.681,591.454,764.513Z"
          transform="translate(182.649 -296.139)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_568"
          data-name="Path 568"
          d="M592.149,764.284l-1.362,1.223v-8.934l1.362.649Z"
          transform="translate(182.649 -302.805)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(819 493)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_RR_Door_Lock-2"
          data-name="RHT RR Door Lock"
          transform="translate(840 494)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_rr_door_lock' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['roof'] || ''"
        [attr.data-name]="'exterior.sedan.roof' | translate"
        transform="translate(28 5)"
      >
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="60"
          height="18"
          rx="9"
          transform="translate(817 513)"
          fill="#242e3a"
          opacity="0.066"
        />
        <path
          id="Path_326"
          data-name="Path 326"
          d="M6217,1348l73.548,88h20.164"
          transform="translate(-5493.049 -913)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 513)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_54"
          data-name="Ellipse 54"
          cx="3"
          cy="3"
          r="3"
          transform="translate(721 432)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_589"
          data-name="Path 589"
          d="M299.006,525.714s7.265,80.069,4.152,107.2c0,0,54.121,10.231,90.6,0,0,0,0-76.405,5.338-107.2,0,0-31.126-6.069-51.044-5.335C348.048,520.379,315.909,520.487,299.006,525.714Z"
          transform="translate(355.328 -162.987)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(819 525)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Roof-2"
          data-name="Roof"
          transform="translate(840 525)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.roof' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_quarter'] || ''"
        [attr.data-name]="'exterior.sedan.rht_quarter' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_327"
          data-name="Path 327"
          d="M6221.185,1347.283,6265.4,1402h13.269"
          transform="translate(-5461.001 -849)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(817 544)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 544)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_57"
          data-name="Ellipse 57"
          cx="3"
          cy="3"
          r="3"
          transform="translate(758 495)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_607"
          data-name="Path 607"
          d="M555.621,806.282v0l-1.279,32.729s-7.673,28.58-14.79,30.026l1.223-18.868s.333-16.607-1.223-29.062-1.668-26.356-1.891-27.468l5.794-1.179s.73,13.116,2.473,13.82Z"
          transform="translate(214.089 -324.044)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(819 556)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Quarter-2"
          data-name="RHT Quarter"
          transform="translate(840 556)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_quarter' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['back_screen'] || ''"
        [attr.data-name]="'exterior.sedan.back_screen' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_328"
          data-name="Path 328"
          d="M6217,1348l73.547,85h20.165"
          transform="translate(-5493.049 -849)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="94"
          height="18"
          rx="9"
          transform="translate(817 575)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 575)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_58"
          data-name="Ellipse 58"
          cx="3"
          cy="3"
          r="3"
          transform="translate(721 496)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_609"
          data-name="Path 609"
          d="M395.044,796.168l4.077,53.75a244.092,244.092,0,0,1-49.784,4.967c-28.358,0-48.153-5.115-48.153-5.115l3.262-53.6s29.114,4.613,44.891,4.473A163.111,163.111,0,0,0,395.044,796.168Z"
          transform="translate(354.038 -326.237)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(819 587)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Back_Screen_2"
          data-name="Back Screen "
          transform="translate(840 587)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.back_screen' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_lamp'] || ''"
        [attr.data-name]="'exterior.sedan.rht_rr_light' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_329"
          data-name="Path 329"
          d="M6217,1348l48.4,70h13.269"
          transform="translate(-5460.001 -803)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="99"
          height="19"
          rx="9.5"
          transform="translate(817 606)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 606)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_59"
          data-name="Ellipse 59"
          cx="3"
          cy="3"
          r="3"
          transform="translate(754 542)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_612"
          data-name="Path 612"
          d="M557.083,906.506l-.945,18.238A26.371,26.371,0,0,1,545.3,937.366l-3-.834S548.52,936.865,557.083,906.506Z"
          transform="translate(211.348 -391.536)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(819 618)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_RR_Light-2"
          data-name="RHT RR Light"
          transform="translate(840 619)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_rr_light' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_bumper'] || ''"
        [attr.data-name]="'exterior.sedan.rr_bumper' | translate"
      >
        <path
          id="Path_330"
          data-name="Path 330"
          d="M6217,1348l79.788,87h21.877"
          transform="translate(-5472.001 -784)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="95"
          height="19"
          rx="9.5"
          transform="translate(845 643)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(845 643)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_60"
          data-name="Ellipse 60"
          cx="3"
          cy="3"
          r="3"
          transform="translate(742 561)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_616"
          data-name="Path 616"
          d="M265.506,951.185s6.335,24.132,62.717,24.132,62.943-21.648,64.111-24.132a3.217,3.217,0,0,0-.1.706,17.229,17.229,0,0,1-.464,1.941,23.035,23.035,0,0,1-1.08,2.892,26.559,26.559,0,0,1-1.946,3.557,29.808,29.808,0,0,1-3.063,3.937,34.488,34.488,0,0,1-4.429,4.031,42.227,42.227,0,0,1-6.046,3.84,54.812,54.812,0,0,1-7.913,3.363,74.555,74.555,0,0,1-10.03,2.6,104.587,104.587,0,0,1-12.4,1.554c-2.908.2-5.822.3-8.736.311-4.332.022-8.665.021-13,.125q-3.147.075-6.294-.044-3.976-.148-7.933-.6A87.346,87.346,0,0,1,300,977.9a69.357,69.357,0,0,1-9.224-2.71,52.82,52.82,0,0,1-8.877-4.259,41.147,41.147,0,0,1-7.868-6.137,36.14,36.14,0,0,1-6.2-8.345A37.342,37.342,0,0,1,265.506,951.185Z"
          transform="translate(403.153 -412.978)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(847 655)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RR_Bumper-2"
          data-name="RR Bumper"
          transform="translate(868 655)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rr_bumper' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['others'] || ''"
        [attr.data-name]="'exterior.sedan.other_1' | translate"
      >
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="95"
          height="19"
          rx="9.5"
          transform="translate(731 670)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(731 670)"
          fill="#3BBC8A"
        />
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(733 682)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Other_1-2"
          data-name="Other 1"
          transform="translate(751 683)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.other_1' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['tires'] || ''"
        [attr.data-name]="'exterior.sedan.tyres' | translate"
      >
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="95"
          height="19"
          rx="9.5"
          transform="translate(845 670)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(845 670)"
          fill="#3BBC8A"
        />
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(847 683)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Tyres-2"
          data-name="Tyres"
          transform="translate(868 683)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.tyres' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_grill'] || ''"
        [attr.data-name]="'exterior.sedan.frt_grill' | translate"
        transform="translate(28 5)"
      >
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="94"
          height="18"
          rx="9"
          transform="translate(817 101)"
          fill="#242e3a"
          opacity="0.066"
        />
        <path
          id="Path_21"
          data-name="Path 21"
          d="M6157,1064.11l90.924-84.453h22.344"
          transform="translate(-5453.048 -870.11)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <g id="Group_129" data-name="Group 129" transform="translate(14 -5)">
          <circle
            class="score-bg"
            id="Ellipse_21-16"
            data-name="Ellipse 21"
            cx="9"
            cy="9"
            r="11"
            transform="translate(803 106)"
            fill="#3BBC8A"
          />
        </g>
        <circle
          id="Ellipse_37"
          data-name="Ellipse 37"
          cx="3"
          cy="3"
          r="3"
          transform="translate(701 191)"
          class="arrowDot"
          fill="#696969"
        />
        <g
          id="Path_573"
          data-name="Path 573"
          transform="translate(350.337 78.076)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M400.3,130.3s-5.112-9.193-49-9.193c-37.256.7-43.859,8.735-43.859,8.735,3.314-4.427,6.952-9.2,11.467-12.327s10.444-3.291,15.74-3.577c11.263-.607,22.766-1.242,34.139-.8,8.081.311,17.878.6,23.638,7.186A121.943,121.943,0,0,1,400.3,130.3Z"
            stroke="none"
          />
          <path
            d="M 309.7881774902344 127.559196472168 C 311.0370178222656 126.8731994628906 312.7989501953125 126.0709533691406 315.239990234375 125.2599258422852 C 318.9302368164062 124.0338668823242 323.4440002441406 123.0278701782227 328.6559753417969 122.269889831543 C 335.1553039550781 121.3246917724609 342.7701416015625 120.7637634277344 351.2889099121094 120.602668762207 C 351.2920837402344 120.6026077270508 351.2952270507812 120.6025772094727 351.2983703613281 120.6025772094727 C 360.5118713378906 120.6025772094727 368.7245178222656 121.0119247436523 375.7082214355469 121.8192672729492 C 381.4542236328125 122.483528137207 386.4177856445312 123.4216079711914 390.4610595703125 124.6074676513672 C 393.7949829101562 125.5852890014648 396.07861328125 126.6011657714844 397.6319580078125 127.4920120239258 C 395.8994750976562 125.2054290771484 394.0295104980469 122.9127807617188 392.0469360351562 120.6455078125 C 389.5886535644531 117.8340911865234 386.1496276855469 115.9532775878906 381.5333862304688 114.8956069946289 C 377.4644165039062 113.9633255004883 373.0189208984375 113.7928771972656 369.0967407226562 113.6425018310547 L 368.7657165527344 113.6297988891602 C 366.2313842773438 113.5321960449219 363.6458435058594 113.484748840332 360.8612976074219 113.484748840332 C 352.2535095214844 113.484748840332 343.5364074707031 113.9550094604492 335.1063537597656 114.4097900390625 L 334.6727294921875 114.4331741333008 C 334.3992614746094 114.4479293823242 334.1241455078125 114.4623260498047 333.84765625 114.4767990112305 C 331.3096313476562 114.6095962524414 328.6852416992188 114.7469177246094 326.1602478027344 115.2187271118164 C 323.32958984375 115.7476348876953 321.0499267578125 116.6316604614258 319.19091796875 117.9213180541992 C 315.5411987304688 120.4530715942383 312.4251403808594 124.1349411010742 309.7881774902344 127.559196472168 M 400.3019104003906 130.2958831787109 C 400.2535400390625 130.2272491455078 400.2052612304688 130.158935546875 400.1567077636719 130.0903930664062 C 400.2614135742188 130.2230529785156 400.3019104003906 130.2958831787109 400.3019104003906 130.2958831787109 Z M 400.1567077636719 130.0903930664062 C 399.0849914550781 128.7324371337891 391.2841796875 121.1025772094727 351.2983703613281 121.1025772094727 C 314.0423278808594 121.8071060180664 307.43896484375 129.8378753662109 307.43896484375 129.8378753662109 C 310.752685546875 125.4106140136719 314.390869140625 120.6425247192383 318.9059143066406 117.5104827880859 C 323.4307250976562 114.3714828491211 329.3494873046875 114.2196197509766 334.6457824707031 113.9339065551758 C 343.2977905273438 113.4673004150391 352.0935974121094 112.984748840332 360.8612976074219 112.984748840332 C 363.507080078125 112.984748840332 366.1485595703125 113.0286331176758 368.7849426269531 113.1301651000977 C 376.8659362792969 113.4412078857422 386.6633605957031 113.7289886474609 392.42333984375 120.3163833618164 C 395.1536254882812 123.4387359619141 397.7577819824219 126.7037200927734 400.1567077636719 130.0903930664062 Z"
            stroke="none"
            fill="#030504"
          />
        </g>
        <text
          id="FRT_Grill-2"
          data-name="FRT Grill"
          transform="translate(840 113)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.frt_grill' | translate }}</tspan>
        </text>
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(818 113)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_head_lamp'] || ''"
        [attr.data-name]="'exterior.sedan.rht_head_light' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_23"
          data-name="Path 23"
          d="M6207,1104.212l45.364-44.914h22.979"
          transform="translate(-5451 -894.012)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <g id="Group_1305" data-name="Group 1305">
          <g id="Group_90" data-name="Group 90" transform="translate(817.377 156.279)">
            <rect
              id="Rectangle_38-17"
              data-name="Rectangle 38"
              width="114"
              height="18"
              rx="9"
              transform="translate(-0.377 -0.279)"
              fill="#242e3a"
              opacity="0.066"
            />
          </g>
        </g>
        <circle
          class="score-bg"
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 156)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_231"
          data-name="Ellipse 231"
          cx="3"
          cy="3"
          r="3"
          transform="translate(754 207)"
          class="arrowDot"
          fill="#696969"
        />
        <g
          id="Path_575"
          data-name="Path 575"
          transform="translate(228.051 68.129)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M542.765,174.412s-13.912-30.191-28.7-44.619C514.069,129.793,546.249,139.808,542.765,174.412Z"
            stroke="none"
          />
          <path
            d="M 542.4200439453125 172.5211181640625 C 542.8834228515625 165.4337615966797 541.8367919921875 158.8960876464844 539.3018798828125 153.0625152587891 C 537.0999755859375 147.9952697753906 533.7745361328125 143.4400329589844 529.4179077148438 139.5233612060547 C 525.5320434570312 136.0299682617188 521.5275268554688 133.7009887695312 518.8524169921875 132.3623504638672 C 517.7637939453125 131.8176116943359 516.8009643554688 131.3881378173828 516.0215454101562 131.0637512207031 C 518.9464721679688 134.1486206054688 522.0261840820312 138.00732421875 525.199951171875 142.5657806396484 C 528.2017822265625 146.8773040771484 531.2954711914062 151.8229522705078 534.3952026367188 157.2653656005859 C 538.2040405273438 163.9528961181641 541.0943603515625 169.7733612060547 542.4200439453125 172.5211181640625 M 542.7645263671875 174.4116668701172 C 542.7645263671875 174.4116668701172 528.8528442382812 144.2209625244141 514.0689697265625 129.7929992675781 C 514.0689697265625 129.7929992675781 546.249267578125 139.8075866699219 542.7645263671875 174.4116668701172 Z"
            stroke="none"
            fill="#030504"
          />
        </g>
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(819 169)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Head_Light-2"
          data-name="RHT Head Light"
          transform="translate(840 168)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_head_light' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_fender'] || ''"
        [attr.data-name]="'exterior.sedan.rht_fender' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_25"
          data-name="Path 25"
          d="M6226.864,1146.682l28.671-48.217h16.171"
          transform="translate(-5452.021 -906.465)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="94"
          height="18"
          rx="9"
          transform="translate(817 183)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 183)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_45"
          data-name="Ellipse 45"
          cx="3"
          cy="3"
          r="3"
          transform="translate(772 238)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_585"
          data-name="Path 585"
          d="M575.771,216.7l-6.276-9.675s1.14,8.563.41,13.095l-3.336-6.534-.361,46.762s1.9,9.119-6.278,17.682c1.311-1.057,5.367-2.03,3.292,9.267,0,0,2.576-1.427,5.356,2.41,0,0,1.115-4,6.935-3.262Z"
          transform="translate(200.911 22.424)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(819 195)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Fender-2"
          data-name="RHT Fender"
          transform="translate(840 195)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_fender' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['windshield'] || ''"
        [attr.data-name]="'exterior.sedan.windshield' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_588"
          data-name="Path 588"
          d="M385.817,426.7l9.1-52.52a.574.574,0,0,1-.318-.165,15.236,15.236,0,0,1-1.5-5.143,10.711,10.711,0,0,0-2.3-5.208s-14.811-10.006-55.938-10.628-53.5,9.386-56.09,13.612c0,0-.662,6.858-2.2,7.674l9.156,52.378S326.878,414.687,385.817,426.7Z"
          transform="translate(368.602 -63.971)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Windshield-2" data-name="Windshield">
          <path
            id="Path_26"
            data-name="Path 26"
            d="M6201.455,1185.658l56.687-59h25.564"
            transform="translate(-5459.455 -880.658)"
            class="arrow"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <rect
            id="Rectangle_38-19"
            data-name="Rectangle 38"
            width="94"
            height="19"
            rx="9.5"
            transform="translate(817 235)"
            fill="#242e3a"
            opacity="0.066"
          />
          <circle
            class="score-bg"
            id="Ellipse_21-19"
            data-name="Ellipse 21"
            cx="9"
            cy="9"
            r="11"
            transform="translate(817 236)"
            fill="#3BBC8A"
          />
          <circle
            id="Ellipse_44"
            data-name="Ellipse 44"
            cx="3"
            cy="3"
            r="3"
            transform="translate(739 302)"
            class="arrowDot"
            fill="#696969"
          />
          <text
            id="_3.0-19"
            data-name="3.0"
            transform="translate(819 248)"
            fill="#030303"
            font-size="10"
            font-weight="800"
          >
            <tspan x="0" y="0" class="score">5.0</tspan>
          </text>
          <text
            id="Windshield-3"
            data-name="Windshield"
            transform="translate(840 248)"
            fill="#242e3a"
            font-size="10"
            font-weight="600"
          >
            <tspan x="0" y="0">{{ 'exterior.sedan.windshield' | translate }}</tspan>
          </text>
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_door'] || ''"
        [attr.data-name]="'exterior.sedan.rht_door' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_559"
          data-name="Path 559"
          d="M568.9,401.369s-5-1.214-6.935,3.262-13.845,58.717-13.178,95.082l11.955-6.617s7.173-1.612,9.119-3.892Z"
          transform="translate(207.518 -92.504)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_322"
          data-name="Path 322"
          d="M6224,1211.113l30.559-42.867h20.01"
          transform="translate(-5453.022 -860.113)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="94"
          height="18"
          rx="9"
          transform="translate(817 299)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 299)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_48"
          data-name="Ellipse 48"
          cx="3"
          cy="3"
          r="3"
          transform="translate(768 348)"
          class="arrowDot"
          fill="#696969"
        />
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(819 311)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Door-2"
          data-name="RHT Door"
          transform="translate(840 311)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_door' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rv_mirror'] || ''"
        [attr.data-name]="'exterior.sedan.rht_mirror' | translate"
        transform="translate(28 5)"
      >
        <path
          id="Path_27"
          data-name="Path 27"
          d="M6224,1226.526l27.836-58.279h18.228"
          transform="translate(-5448.518 -895.113)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="94"
          height="18"
          rx="9"
          transform="translate(817 264)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(817 264)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_47"
          data-name="Ellipse 47"
          cx="3"
          cy="3"
          r="3"
          transform="translate(772 329)"
          class="arrowDot"
          fill="#696969"
        />
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(819 277)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Mirror-2"
          data-name="RHT Mirror"
          transform="translate(840 276)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.rht_mirror' | translate }}</tspan>
        </text>
        <path
          id="Path_572"
          data-name="Path 572"
          d="M584.868,462.035s12.9,9.564,14.679,9.193,4.077-4.374-1.779-11.714-10.453-6.672-10.453-6.672S583.608,450.693,584.868,462.035Z"
          transform="translate(186.307 -122.959)"
          fill="#fff"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_head_lamp'] || ''"
        [attr.data-name]="'exterior.sedan.lft_head_light' | translate"
      >
        <path
          id="Path_41"
          data-name="Path 41"
          d="M6098.849,1110.148l-63.319-61.925h-34.719"
          transform="translate(-5411.258 -902.148)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="107"
          height="18"
          rx="9"
          transform="translate(489 137)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 137)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_39"
          data-name="Ellipse 39"
          cx="3"
          cy="3"
          r="3"
          transform="translate(684 205)"
          class="arrowDot"
          fill="#696969"
        />
        <g
          id="Path_574"
          data-name="Path 574"
          transform="translate(408.539 72.638)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M256.669,175.819s14.026-30.77,28.81-45.2C285.479,130.621,253.184,141.215,256.669,175.819Z"
            stroke="none"
          />
          <path
            d="M 257.0123291015625 173.911865234375 C 258.3450622558594 171.1191101074219 261.2588806152344 165.1866455078125 265.0941772460938 158.3848571777344 C 268.2104187011719 152.8582458496094 271.3173522949219 147.8454895019531 274.3286743164062 143.4858093261719 C 277.4932861328125 138.9041748046875 280.5611877441406 135.0345153808594 283.4721374511719 131.950439453125 C 282.7079162597656 132.2825469970703 281.7723388671875 132.7165374755859 280.7162780761719 133.2613830566406 C 275.850341796875 135.7718048095703 272.2595825195312 138.6447448730469 270.1041870117188 140.61279296875 C 265.7219848632812 144.6140441894531 262.3760070800781 149.2382507324219 260.1591491699219 154.3569946289062 C 257.6082153320312 160.2471466064453 256.552001953125 166.8173065185547 257.0123291015625 173.911865234375 M 256.6687622070312 175.8188934326172 C 253.1844329833984 141.2152099609375 285.4785461425781 130.6210021972656 285.4785461425781 130.6210021972656 C 270.6946716308594 145.0489654541016 256.6687622070312 175.8188934326172 256.6687622070312 175.8188934326172 Z"
            stroke="none"
            fill="#030504"
          />
        </g>
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(580 149)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Head_Light-2"
          data-name="LFT Head Light"
          transform="translate(499 149)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_head_light' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_fender'] || ''"
        [attr.data-name]="'exterior.sedan.lft_fender' | translate"
      >
        <path
          id="Path_42"
          data-name="Path 42"
          d="M6073.819,1151.653l-48.7-66.041-28.424-.959"
          transform="translate(-5410.819 -906.653)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="86"
          height="18"
          rx="9"
          transform="translate(510 169)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 169)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_41"
          data-name="Ellipse 41"
          cx="3"
          cy="3"
          r="3"
          transform="translate(660 242)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_584"
          data-name="Path 584"
          d="M243.156,216.454l6.617-9.842s-1.918,8.257-.751,13.262l3.336-6.534.362,46.762s-1.9,9.119,6.278,17.682c-1.311-1.057-5.778-1.557-2.979,9.341,0,0-4.689,1.3-4.495,2.363,0,0-2.289-4.031-8.109-3.29Z"
          transform="translate(416.38 27.666)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(580 181)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Fender-2"
          data-name="LFT Fender"
          transform="translate(518 181)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_fender' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['wipers'] || ''"
        [attr.data-name]="'exterior.sedan.wipers' | translate"
      >
        <path
          id="Path_44"
          data-name="Path 44"
          d="M6106.161,1169.653l-70.928-85h-38.541"
          transform="translate(-5411.819 -874.653)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="83"
          height="18"
          rx="9"
          transform="translate(510 199)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 199)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_42"
          data-name="Ellipse 42"
          cx="3"
          cy="3"
          r="3"
          transform="translate(691 292)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_43"
          data-name="Path 43"
          d="M0,0,21.91,2.48,47.1,0,21.91,3.288Z"
          transform="translate(697.732 296.777) rotate(22)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
          opacity="0.661"
        />
        <path
          id="Path_321"
          data-name="Path 321"
          d="M0,0,21.91,2.48,47.1,0,21.91,3.288Z"
          transform="translate(731.499 293.831) rotate(14)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
          opacity="0.661"
        />
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(580 211)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="wipers-2"
          data-name="wipers"
          transform="translate(522 211)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.wipers' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_mud_guard'] || ''"
        [attr.data-name]="'exterior.sedan.lft_mud_guard' | translate"
      >
        <path
          id="Path_46"
          data-name="Path 46"
          d="M6068.821,1123.846l-42.075-39.193h-30.053"
          transform="translate(-5409.727 -843.53)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="104"
          height="18"
          rx="9"
          transform="translate(492 230)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 230)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_43"
          data-name="Ellipse 43"
          cx="3"
          cy="3"
          r="3"
          transform="translate(655 276)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_622"
          data-name="Path 622"
          d="M238.4,230.723l-1.737,2.6-1.571,51.265,3.521,3.477Z"
          transform="translate(421.152 13.397)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(580 242)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Mud_Guard-2"
          data-name="LFT Mud Guard"
          transform="translate(498 243)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_mud_guard' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_frt_door'] || ''"
        [attr.data-name]="'exterior.sedan.lft_door' | translate"
      >
        <path
          id="Path_46-2"
          data-name="Path 46"
          d="M6079.923,1136.813l-48.551-52.159h-34.681"
          transform="translate(-5411.012 -782.813)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="82"
          height="19"
          rx="9.5"
          transform="translate(514 292)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          id="Ellipse_72"
          data-name="Ellipse 72"
          cx="3"
          cy="3"
          r="3"
          transform="translate(666 351)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_593"
          data-name="Path 593"
          d="M242.392,401.33s5-1.214,6.935,3.262,13.845,58.717,13.178,95.082l-11.955-6.617s-7.173-1.612-9.119-3.892Z"
          transform="translate(417.401 -87.481)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 292)"
          fill="#3BBC8A"
        />
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(580 304)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Door-2"
          data-name="LFT Door"
          transform="translate(528 305)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_door' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rocker_panel'] || ''"
        [attr.data-name]="'exterior.sedan.lft_rocker_pannel' | translate"
      >
        <path
          id="Path_46-3"
          data-name="Path 46"
          d="M6079.983,1115.736l-48.586-31.083h-34.706"
          transform="translate(-5418.787 -752.813)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="117"
          height="18"
          rx="9"
          transform="translate(479 323)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 323)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_71"
          data-name="Ellipse 71"
          cx="3"
          cy="3"
          r="3"
          transform="translate(657 359)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_605"
          data-name="Path 605"
          d="M241.745,401.3s2.562-.54,3.976.3l-1.463,63.123-.3,14.962.011,9.388.081,2.1s.288,9.278.248,17.2-.248,29.192-.248,29.192l-3.713-.278Z"
          transform="translate(418.048 -87.45)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(580 335)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Rocker_Pannel-2"
          data-name="LFT Rocker Pannel"
          transform="translate(482 335)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_rocker_pannel' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_frt_window'] || ''"
        [attr.data-name]="'exterior.sedan.lft_frt_window' | translate"
      >
        <path
          id="Path_46-4"
          data-name="Path 46"
          d="M6092.374,1096.813l-55.814-12.159H5996.69"
          transform="translate(-5417.787 -721.813)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="116"
          height="18"
          rx="9"
          transform="translate(480 354)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 354)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_70"
          data-name="Ellipse 70"
          cx="3"
          cy="3"
          r="3"
          transform="translate(672 372)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_594"
          data-name="Path 594"
          d="M273.629,522.655s-9.267-5.264-10.231-7.562-.848-62.054-.848-62.054l4.273,3.708s7.407,35.363,8.145,65.908v.723Z"
          transform="translate(404.905 -118.171)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(580 366)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_FRT_Window-2"
          data-name="LFT FRT Window"
          transform="translate(491 366)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_frt_window' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_frt_door_lock'] || ''"
        [attr.data-name]="'exterior.sedan.lft_frt_door_lock' | translate"
      >
        <path
          id="Path_46-5"
          data-name="Path 46"
          d="M6068.467,1084.653,6026.6,1103.5H5996.69"
          transform="translate(-5406.787 -704.502)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-29"
          data-name="Rectangle 38"
          width="128"
          height="18"
          rx="9"
          transform="translate(468 390)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-29"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 390)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_69"
          data-name="Ellipse 69"
          cx="3"
          cy="3"
          r="3"
          transform="translate(657 378)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_596"
          data-name="Path 596"
          d="M241.431,580.725s1.687,1.446,1.835.964c.057-.186.125-2.867.151-6.19.041-5.288-.024-12.2-.411-13.271-1-1.335-1.345.963-1.345.963Z"
          transform="translate(417.401 -182.543)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_597"
          data-name="Path 597"
          d="M243.534,581.372l-1.906-.871.1-7.581,1.72-1.185Z"
          transform="translate(417.284 -188.417)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-29"
          data-name="3.0"
          transform="translate(580 402)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_FRT_Door_Lock-2"
          data-name="LFT FRT Door Lock"
          transform="translate(481 402)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_frt_door_lock' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_door'] || ''"
        [attr.data-name]="'exterior.sedan.lft_rr_door' | translate"
      >
        <path
          id="Path_46-6"
          data-name="Path 46"
          d="M6088.491,1084.653l-53.549,11h-38.251"
          transform="translate(-5417.787 -655.653)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-30"
          data-name="Rectangle 38"
          width="103"
          height="18"
          rx="9"
          transform="translate(493 432)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-30"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 432)"
          fill="#3BBC8A"
        />
        <path
          id="Path_598"
          data-name="Path 598"
          d="M261.857,627.238c-.338.008.715,71.031-3.6,75.028H247.957S242,696.3,240.864,689.625s-.08-72.9-.08-72.9,2.28,2.391,9.119,3.892Z"
          transform="translate(418.048 -215.044)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-30"
          data-name="3.0"
          transform="translate(580 444)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_RR_Door-2"
          data-name="LFT RR Door"
          transform="translate(512 445)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_rr_door' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_window'] || ''"
        [attr.data-name]="'exterior.sedan.lft_rr_window' | translate"
      >
        <path
          id="Path_46-7"
          data-name="Path 46"
          d="M6094.413,1084.653l-57,39.333h-40.717"
          transform="translate(-5417.788 -646.146)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-31"
          data-name="Rectangle 38"
          width="118"
          height="18"
          rx="9"
          transform="translate(478 468)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-31"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 468)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_66"
          data-name="Ellipse 66"
          cx="3"
          cy="3"
          r="3"
          transform="translate(673 436)"
          class="arrowDot"
          fill="#696969"
        />
        <text
          id="_3.0-31"
          data-name="3.0"
          transform="translate(580 480)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_RR_Window-2"
          data-name="LFT RR Window"
          transform="translate(497 481)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_rr_window' | translate }}</tspan>
        </text>
        <path
          id="Path_599"
          data-name="Path 599"
          d="M277.439,651.664l-10.628-3.741,2.536,44.779,7.537,2.058Z"
          transform="translate(402.381 -233.505)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_door_lock'] || ''"
        [attr.data-name]="'exterior.sedan.lft_rr_door_lock' | translate"
      >
        <path
          id="Path_46-8"
          data-name="Path 46"
          d="M6080.087,1084.654l-36.722,32.19-5.992,4.538-40.682.112"
          transform="translate(-5417.787 -614.654)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-32"
          data-name="Rectangle 38"
          width="130"
          height="18"
          rx="9"
          transform="translate(465 497)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-32"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 497)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_65"
          data-name="Ellipse 65"
          cx="3"
          cy="3"
          r="3"
          transform="translate(660 467)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_601"
          data-name="Path 601"
          d="M247.068,764.474s-1.334.816-1.557-4.56,0-10.787,0-10.787.148-3.521.964-3.818,1.261,1.223,1.261,1.223v17.126S247.679,764.642,247.068,764.474Z"
          transform="translate(415.045 -291.116)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_602"
          data-name="Path 602"
          d="M247.766,764.245l1.362,1.223v-8.934l-1.362.649Z"
          transform="translate(413.652 -297.782)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-32"
          data-name="3.0"
          transform="translate(580 509)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_RR_Door_Lock-2"
          data-name="LFT RR Door Lock"
          transform="translate(486 510)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_rr_door_lock' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['anntena'] || ''"
        [attr.data-name]="'exterior.sedan.antenna' | translate"
      >
        <path
          id="Path_46-9"
          data-name="Path 46"
          d="M6146.788,1129.874l-106.875,67.841h-43.221"
          transform="translate(-5414.788 -661.874)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-33"
          data-name="Rectangle 38"
          width="83"
          height="18"
          rx="9"
          transform="translate(513 526)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-33"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 526)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="3"
          cy="3"
          r="3"
          transform="translate(729 465)"
          class="arrowDot"
          fill="#696969"
        />
        <rect
          id="Rectangle_188"
          data-name="Rectangle 188"
          width="2.654"
          height="4.412"
          rx="1.327"
          transform="translate(730.781 468.432)"
          fill="#030504"
        />
        <line
          id="Line_43"
          data-name="Line 43"
          y2="23.761"
          transform="translate(732.108 470.638)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-33"
          data-name="3.0"
          transform="translate(580 538)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Antenna-2"
          data-name="Antenna"
          transform="translate(532 538)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.antenna' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_quarter'] || ''"
        [attr.data-name]="'exterior.sedan.lft_quarter' | translate"
      >
        <path
          id="Path_46-10"
          data-name="Path 46"
          d="M6087.787,1084.654l-53.138,56.841H5996.69"
          transform="translate(-5411.787 -572.654)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-34"
          data-name="Rectangle 38"
          width="90"
          height="18"
          rx="9"
          transform="translate(506 558)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-34"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 558)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_64"
          data-name="Ellipse 64"
          cx="3"
          cy="3"
          r="3"
          transform="translate(673 509)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_608"
          data-name="Path 608"
          d="M260.063,806.282v0l1.279,32.729s7.674,28.58,14.791,30.026l-1.223-18.868s-.333-16.607,1.223-29.062,1.668-26.356,1.89-27.468l-5.794-1.179s-.73,13.116-2.472,13.82Z"
          transform="translate(406.374 -319.044)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-34"
          data-name="3.0"
          transform="translate(580 570)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Quarter-2"
          data-name="LFT Quarter"
          transform="translate(514 570)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_quarter' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['trunk_cargo'] || ''"
        [attr.data-name]="'exterior.sedan.trunk_cargo' | translate"
      >
        <path
          id="Path_46-11"
          data-name="Path 46"
          d="M6096.544,1084.654l-58.247,63.841h-41.606"
          transform="translate(-5411.788 -548.654)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-35"
          data-name="Rectangle 38"
          width="91"
          height="18"
          rx="9"
          transform="translate(505 591)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-35"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 591)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_63"
          data-name="Ellipse 63"
          cx="3"
          cy="3"
          r="3"
          transform="translate(683 533)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_615"
          data-name="Path 615"
          d="M296.434,930.078l1.939-2.595s19.016,5,48.153,5.115c0,0,32.287-.7,49.783-4.967l1.705,2.446L397.047,945s-13.934,12.8-50.521,12.211c0,0-30.656,1.323-49.042-12.461Z"
          transform="translate(384.85 -398.951)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-35"
          data-name="3.0"
          transform="translate(580 603)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Trunk_Cargo-2"
          data-name="Trunk/Cargo"
          transform="translate(512 603)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.trunk_cargo' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_lamp'] || ''"
        [attr.data-name]="'exterior.sedan.lft_rr_light' | translate"
      >
        <path
          id="Path_46-12"
          data-name="Path 46"
          d="M6095.011,1084.653l-57.352,79.841h-40.967"
          transform="translate(-5411.788 -534.653)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-36"
          data-name="Rectangle 38"
          width="102"
          height="18"
          rx="9"
          transform="translate(494 621)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-36"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 621)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_62"
          data-name="Ellipse 62"
          cx="3"
          cy="3"
          r="3"
          transform="translate(680 547)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_613"
          data-name="Path 613"
          d="M263.19,906.506l.945,18.238s1.441,6.124,10.975,12.585l2.87-.8S271.753,936.865,263.19,906.506Z"
          transform="translate(404.523 -386.536)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-36"
          data-name="3.0"
          transform="translate(580 633)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="_LFT_RR_Light-2"
          data-name=" LFT RR Light"
          transform="translate(508 633)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0" xml:space="preserve">
            {{ 'exterior.sedan.lft_rr_light' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_bumper'] || ''"
        [attr.data-name]="'exterior.sedan.frt_bumper' | translate"
      >
        <path
          id="Path_40"
          data-name="Path 40"
          d="M6123.028,1097.71l-83.178-79.934h-31.7"
          transform="translate(-5412.043 -902.71)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-37"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(497 106)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-37"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 106)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_38"
          data-name="Ellipse 38"
          cx="3"
          cy="3"
          r="3"
          transform="translate(709 193)"
          class="arrowDot"
          fill="#696969"
        />
        <path
          id="Path_586"
          data-name="Path 586"
          d="M339.7,114s1.817-2.807,30.692-3.345c0,0,28.98-.769,34.357,2.5l-2.257-2.033s-7.706-3-32.1-2.224S342.295,109.765,339.7,114Z"
          transform="translate(359.246 85.574)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Bumper-2"
          data-name="FRT Bumper"
          transform="translate(513 119)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.frt_bumper' | translate }}</tspan>
        </text>
        <text
          id="_3.0-37"
          data-name="3.0"
          transform="translate(580 117)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rv_mirror'] || ''"
        [attr.data-name]="'exterior.sedan.lft_mirror' | translate"
      >
        <path
          id="Path_606"
          data-name="Path 606"
          d="M232.494,462s-12.9,9.564-14.679,9.193-4.078-4.374,1.779-11.714,10.453-6.673,10.453-6.673S233.754,450.654,232.494,462Z"
          transform="translate(432.547 -117.935)"
          fill="#fff"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_46-13"
          data-name="Path 46"
          d="M6074.984,1150.685l-46.563-66.032h-31.729"
          transform="translate(-5414.517 -812.653)"
          class="arrow"
          fill="none"
          stroke="#707070"
          stroke-width="2"
          stroke-dasharray="2"
        />
        <rect
          id="Rectangle_38-38"
          data-name="Rectangle 38"
          width="83"
          height="18"
          rx="9"
          transform="translate(513 263)"
          fill="#242e3a"
          opacity="0.066"
        />
        <circle
          class="score-bg"
          id="Ellipse_21-38"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(578 263)"
          fill="#3BBC8A"
        />
        <circle
          id="Ellipse_73"
          data-name="Ellipse 73"
          cx="3"
          cy="3"
          r="3"
          transform="translate(658 335)"
          class="arrowDot"
          fill="#696969"
        />
        <text
          id="_3.0-38"
          data-name="3.0"
          transform="translate(580 275)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Mirror-2"
          data-name="LFT Mirror"
          transform="translate(522 275)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.sedan.lft_mirror' | translate }}</tspan>
        </text>
      </g>
    </g>
  </svg>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
    <button type="button" class="close" (click)="modalRef.hide()">
      <i class="bi bi-x"></i>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body h-auto">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  [readonly]="role === 'evaluator' || role === 'qc' || role === 'purchasemanager'"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  [readonly]="role === 'evaluator' || role === 'qc' || role === 'purchasemanager'"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <!-- start -->
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="true"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part change)</option>
                <option [value]="2">2 (Major Repair)</option>
                <option [value]="3">3 (Moderate Repair)</option>
                <option [value]="4">4 (Minor Repair)</option>
                <option [value]="5">5 (Good part)</option>
              </select>
              <!-- end -->

              <!-- <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id" 
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select Severity"
                  [readonly]="role === 'evaluator' || role === 'qc' || role === 'purchasemanager'">
                </ng-select>
              </ng-container> -->

              <!-- <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id" 
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select Severity"
                  [readonly]="role === 'evaluator' || role === 'qc' || role === 'purchasemanager'">
                </ng-select>
              </ng-container> -->
            </div>
          </div>
        </div>

        <!-- <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{ 'condition_modal.description' | translate }}</label>
              <label class="modal_car_input_label">Description</label>
              <textarea class="form-control credential__textarea" formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"></textarea>
            </div>
          </div>
        </div> -->

        <!-- Before Image start -->
        <div class="row mx-n2" *ngIf="imageOld['beforeImg1'] || imageOld['beforeImg2']">
          <!-- Show label only if both Before and After images exist -->
          <div
            class="col-12 px-2"
            *ngIf="
              (imageOld['beforeImg1'] || imageOld['beforeImg2']) &&
              (imageNew['afterImg1'] || imageNew['afterImg2'])
            "
          >
            <label class="credential__label">
              {{ 'condition_modal.before' | translate }}
            </label>
          </div>

          <!-- 1st img -->
          <div class="col-md-6 px-2" *ngIf="imageOld['beforeImg1']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageOld['beforeImg1']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- 2nd image -->
          <div class="col-md-6 px-2" *ngIf="imageOld['beforeImg2']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageOld['beforeImg2']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- end -->

        <!-- After Image start -->
        <div class="row mx-n2" *ngIf="imageNew['afterImg1'] || imageNew['afterImg2']">
          <!-- Show label only if both Before and After images exist -->
          <div
            class="col-12 px-2"
            *ngIf="
              (imageNew['afterImg1'] || imageNew['afterImg2']) &&
              (imageOld['beforeImg1'] || imageOld['beforeImg2'])
            "
          >
            <label class="credential__label">
              {{ 'condition_modal.after' | translate }}
            </label>
          </div>

          <!-- For 1st img -->
          <div class="col-md-6 px-2" *ngIf="imageNew['afterImg1']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageNew['afterImg1']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- For 2nd img -->
          <div class="col-md-6 px-2" *ngIf="imageNew['afterImg2']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageNew['afterImg2']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- end -->
      </div>

      <!-- <loader [active]="loaded"></loader> -->
    </div>
  </form>
</ng-template>
